module.exports = __webpack_public_path__ + "img/group.a42a510a.svg";